/*
 * @LastEditors: Jacky
 * @LastEditTime: 2022-10-12 16:02:48
 * @FilePath: /mojito-swap-interface/src/locales/ru.ts
 * Copyright (c) 2022 by Jacky, All Rights Reserved.
 */
const templates = require.context('./ru/', true, /\.json$/)
let langMap = {}

for (let i = 0; i < templates.keys().length; i++) {
  const key = templates.keys()[i]
  langMap = Object.assign(langMap, templates(key))
}

export default { ...langMap }
